import { Component, Host, h, Prop, Element, Method, Event, EventEmitter } from '@stencil/core';

/**
 * @slot  - Slot to add content to the alert. It is positioned under the alert title.
 */
@Component({
  tag: 'sy-alert',
  styleUrls: ['scss/index.scss', 'scss/_tokens.scss'],
  shadow: true,
})
export class Alert {
  @Element() el: HTMLSyAlertElement;

  /**
   * Title of the alert.
   */
  @Prop() header: string;

  /**
   * If true, the alert can be dimissed by clicking in the close button.
   */
  @Prop({ reflect: true }) dismissible = false;

  /**
   * Defines the color and the icon of the alert.
   */
  @Prop({ reflect: true }) type: 'error' | 'warning' | 'success' | 'info' = 'error';

  /**
   * Emitted after alert is closed.
   */
  @Event() syAlertDidClose: EventEmitter<any>;

  /**
   * Method to close the alert. It will remove the alert from DOM.
   */
  @Method()
  async dismiss(): Promise<void> {
    this.syAlertDidClose.emit();
    this.el.remove();
  }

  private typesIcons = {
    error: 'remove-circle',
    warning: 'alert-circle',
    success: 'check-circle-1',
    info: 'information-circle',
  };

  render() {
    return (
      <Host role="alert">
        <div class="sy-alert-wrapper">
          <div class="sy-alert-icon">
            <sy-icon name={this.typesIcons[this.type]}></sy-icon>
          </div>
          <div class="sy-alert-content">
            <div class="sy-alert-title">{this.header}</div>
            <slot></slot>
          </div>
        </div>
        {this.dismissible ? <sy-dismiss class="sy-alert-dismiss" onClick={() => this.dismiss()}></sy-dismiss> : ''}
      </Host>
    );
  }
}
